import Translate from "@casino/legacy/client/shared/i18n/Translate";
import Img from "@casino/legacy/client/shared/images/Img";
import Container from "./Container";

type Props = {
  logo?: string;
};

const WaitForRedirect: FC<Props> = ({ logo }) => (
  <Container>
    {logo && <Img src={logo} />}
    <Translate id="general.wait_for_redirect" />
  </Container>
);

export default WaitForRedirect;
